import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/** Unset dates come back from the API as 0001-01-01 (or 1900-01-01 from QIN), not null */
export function isSetDate(value: Date | string | undefined | null): boolean {
  if (!value) return false;
  const d = new Date(value as any);
  return !isNaN(d.getTime()) && d.getFullYear() > 2000;
}

/**
 * A date as the portal shows it, or a dash when there isn't one. Use instead of the date
 * pipe for any date that can be unset (delivered at, expected delivery, last export...),
 * which would otherwise print as "Mon 1 Jan 00:00".
 *
 *   {{ shipment.actualDeliveryTime | lbDate:'EEE d MMM HH:mm' }}
 */
@Pipe({ name: 'lbDate' })
export class LbDatePipe implements PipeTransform {
  private readonly date = new DatePipe('en-US');

  transform(value: Date | string | undefined | null, format = 'EEE d MMM', empty = '–'): string {
    if (!isSetDate(value)) return empty;
    return this.date.transform(value, format) || empty;
  }
}
